import { Box, Button, Dialog, DialogContent, IconButton, Typography } from "@mui/material";
import React from "react";
import { ReactComponent as AlertOctagonIcon } from '../../assets/alert-octagon.svg';
import { ReactComponent as ChatIcon } from '../../assets/chat.svg';
import CloseIcon from '@mui/icons-material/Close';
import './tax-id-theft.css';

export interface ItemModalProps {
    onAction: (action:string) => void
    open: boolean;
  }
  
  export function TaxReturnNotFilingModal({ onAction, open = false }: ItemModalProps): React.JSX.Element {
      
    return (
        <Dialog open={open} sx={{justifyContent: 'center'}} maxWidth={'xs'}>
          <IconButton
          aria-label="close"
          onClick={() => onAction('close')}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            bottom: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
            <DialogContent sx={{mt: 2}}>
                <Box sx={{display: 'flex', flexDirection:'column', justifyContent: 'center', alignItems: 'center'}}>
                    <AlertOctagonIcon height={30} width={30}/>
                    <Typography variant="h5" sx={{textAlign: 'center', mt: 2}}>
                    {'Thank you for confirming that you did not file that tax return.'}
                    </Typography>
                    <Typography sx={{textAlign: 'center', mt: 2}}>
                    {`Optima takes your tax ID security seriously. We want to do everything we can to help you remedy this issue. Please select one of the options below to continue.`}
                    </Typography>
                    <Box sx={{mt:3}}>
                      <Button className="option-primary-button me-3" onClick={() => onAction('get-help')}>Upgrade to Get Help</Button>
                      <Button className="option-red-button" onClick={() => onAction('speak-with-agent')}>Speak with an Agent <ChatIcon className="ms-1"/></Button>
                    </Box>
                </Box>
            </DialogContent>
        </Dialog>
      )
    
  }